import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import axios from "axios";
import constantObject from "../../config";
import RSearchBar from "material-ui-search-bar";
import { IoMdCopy } from "react-icons/io";
import { Link, useHistory, useParams } from "react-router-dom";
import { localTimeConvert, formatTimes } from "../../common/Functions";
import { Tooltip } from "@mui/material";
import toast, { Toaster } from 'react-hot-toast';

import "./index.scss";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { BsGraphDown } from "react-icons/bs";

const PendingTransaction = () => {
  const history = useHistory();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  // Function to handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearch = (value) => {
    // setSearchText(value);
    setPage(0);
  };

  // Function to fetch updated transaction data
  useEffect(() => {
    const fetchTransferData = async () => {
      try {
        const response = await axios.get(
          `${
            constantObject.BaseUrl
          }/api/transaction/pending?limit=${rowsPerPage}&page=${page + 1}`
        );

        setTableData(response.data);
        setTotalCount(response.totalCount);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    // Fetch data immediately on mount
    fetchTransferData();

    // Set up interval for fetching updated data
    const intervalId = setInterval(fetchTransferData, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [page, rowsPerPage]);

  function formatValue(value) {
    const numberValue = Number(value);
    return !isNaN(numberValue)
      ? numberValue.toLocaleString("en", { maximumFractionDigits: 18 })
      : "N/A";
  }

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("Copied to clipboard!", {
        style: {
          background: '#4CAF50',
          color: 'white',
          border: "none",
          boxShadow:"none"
        },
      });
    }).catch((err) => {
      toast.error("Failed to copy!", {
        style: {
          background: '#f44336',
          color: 'white',
          border: "none",
          boxShadow:"none"
        },
      });
    });
  };
  

  return (
    <>
      <Navbar />

      <div className="card-page-container">
        <header className="pending-header-section">
          <div className="pending-header-left-section">
            <h1 className="heading-pending-txn">Pending Transactions</h1>
          </div>
        </header>

        <Paper className="paper-style" style={{ marginTop: "1.5rem" }}>
          <TableContainer>
            <div className="pending-searchbar">
              <button variant="outlined" className="pending-btn">
                <Tooltip title="Click to see Pending Transactions Pool" arrow>
                  <BsGraphDown className="mr-2" />
                  <span>Pending Transaction Pool</span>
                </Tooltip>
              </button>

              <RSearchBar
                onChange={handleSearch}
                placeholder="Search by Address"
                className="searchbar-style"
              />
            </div>

            <div className="top-pagination">
              <div>
                <span className="total-pending-txn">
                  A total of {totalCount} pending txns found
                </span>
              </div>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>Txn Hash</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>Method</TableCell>
                  <TableCell style={{ fontWeight: "bold", color: "#0784C3" }}>
                    Nonce
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Last Seen
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", color: "#0784C3" }}>
                    Gas Limit
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", color: "#0784C3" }}>
                    Gas Price
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>From</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>To</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell
                        className="cell-style"
                        style={{ cursor: "pointer" }}
                      >
                        <Tooltip title={row?.hash} arrow>
                          <span
                            style={{ color: "#0784C3" }}
                            onClick={() => {
                              history.push(`/transactions_detail/${row?.hash}`);
                            }}
                          >
                            {row?.hash.length > 25
                              ? `${row?.hash.substring(0, 25)}...`
                              : row?.hash}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell className="cell-style">
                        {row.status === 1 ? (
                          <>
                            <Tooltip title={"Success"} arrow>
                              <Button
                                variant="outlined"
                                color="default"
                                size="small"
                                style={{
                                  fontSize: "11px",
                                  fontWeight: "400",
                                  backgroundColor: "#F8F9FA",
                                  borderRadius: 8,
                                  textTransform: "capitalize",
                                  minWidth: "90px",
                                }}
                              >
                                Success
                              </Button>
                            </Tooltip>
                          </>
                        ) : (
                          <>
                            <Tooltip title={"Failed"} arrow>
                              <Button
                                variant="outlined"
                                color="default"
                                size="small"
                                style={{
                                  fontSize: "11px",
                                  fontWeight: "400",
                                  backgroundColor: "#F8F9FA",
                                  borderRadius: 8,
                                  textTransform: "capitalize",
                                  minWidth: "90px",
                                }}
                              >
                                Failed
                              </Button>
                            </Tooltip>
                          </>
                        )}
                      </TableCell>
                      <TableCell className="cell-style">
                        {row?.nonce ? row?.nonce : "N/A"}
                      </TableCell>
                      <TableCell className="cell-style">
                        <Tooltip
                          title={localTimeConvert(row?.blockTimestamp)}
                          arrow
                        >
                          <span>{formatTimes(row?.blockTimestamp)}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell className="cell-style">
                        {row?.gaslimit ? row?.gaslimit : "N/A"}
                      </TableCell>
                      <TableCell className="cell-style">
                        <Tooltip title={row?.gasprice} arrow>
                          <span>{row?.gasprice ? row?.gasprice : "N/A"}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        className="cell-style"
                        style={{ color: "#0784C3" }}
                      >
                        {row?.tokenData && row?.tokenData.from ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <Tooltip title={row?.tokenData?.from} arrow>
                              <span>
                                {row?.tokenData?.from.length > 16
                                  ? `${row?.tokenData?.from.substring(
                                      0,
                                      8
                                    )}...${row?.tokenData?.from.substring(
                                      row?.tokenData?.from.length - 8
                                    )}`
                                  : row?.tokenData?.from}
                              </span>
                            </Tooltip>
                            <div
                              onClick={() => copyToClipboard(row?.tokenData?.to)}
                              style={{
                                marginLeft: 10,
                                color: "gray",
                                cursor: "pointer",
                              }}
                            >
                              <IoMdCopy style={{ fontSize: "1.2rem" }} />
                            </div>
                            <Toaster position="top-right"/>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <Tooltip title={row?.from} arrow>
                              <span>
                                {row?.from.length > 16
                                  ? `${row?.from.substring(
                                      0,
                                      8
                                    )}...${row?.from.substring(
                                      row?.from.length - 8
                                    )}`
                                  : row?.from}
                              </span>
                            </Tooltip>
                            <div
                              onClick={() => copyToClipboard(row?.from)}
                              style={{
                                marginLeft: 10,
                                color: "gray",
                                cursor: "pointer",
                              }}
                            >
                              <IoMdCopy style={{ fontSize: "1.2rem" }} />
                            </div>
                            <Toaster position="top-right"/>
                          </div>
                        )}
                      </TableCell>
                      <TableCell
                        className="cell-style"
                        style={{ color: "#0784C3" }}
                      >
                        {row?.tokenData && row?.tokenData.to ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <Tooltip title={row?.tokenData?.to} arrow>
                              <span>
                                {row?.tokenData?.to.length > 16
                                  ? `${row?.tokenData?.to.substring(
                                      0,
                                      8
                                    )}...${row?.tokenData?.to.substring(
                                      row?.tokenData?.to.length - 8
                                    )}`
                                  : row?.tokenData?.to}
                              </span>
                            </Tooltip>
                            <div
                              onClick={() => copyToClipboard(row?.tokenData?.to)}
                              style={{
                                marginLeft: 10,
                                color: "gray",
                                cursor: "pointer",
                              }}
                            >
                              <IoMdCopy style={{ fontSize: "1.2rem" }} />
                            </div>
                            <Toaster position="top-right"/>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <Tooltip title={row?.to} arrow>
                              <span>
                                {row?.to.length > 16
                                  ? `${row?.to.substring(
                                      0,
                                      8
                                    )}...${row?.to.substring(row?.to.length - 8)}`
                                  : row?.to}
                              </span>
                            </Tooltip>
                            <div
                              onClick={() => copyToClipboard(row?.to)}
                              style={{
                                marginLeft: 10,
                                color: "gray",
                                cursor: "pointer",
                              }}
                            >
                              <IoMdCopy style={{ fontSize: "1.2rem" }} />
                            </div>
                            <Toaster position="top-right"/>
                          </div>
                        )}
                      </TableCell>
                      <TableCell className="cell-style">
                        ${row.amount || 0}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
      <Footer />
    </>
  );
};

export default PendingTransaction;
